import introJs from 'intro.js'

export function getIntro () {
    var introguide = introJs().setOptions({
        disableInteraction: false
    }).addSteps([
        // {
        //     element: '#data-btn',
        //     intro: 'Filter the data to display here',
        //     position: 'bottom'
        // },

        {
            element: '#layer-filter-container',
            intro: 'Please choose the scale and type of layer.\n This can be changed afterward',
            position: 'right'
        },
        // {
        //     element: '#spatial-scale-container',
        //     intro: 'Toggle between global or regional products here',
        //     position: 'right'
        // },
        {
            element: '#indicator-container',
            intro: 'Choose which indicators to include in the assessment here. For some filters, no data might be currently available',
            position: 'right'
        },
        {
            element: '#date-container',
            intro: 'Some layers also support filtering data by month and year.',
            position: 'right'
        }
        // {
        //     element: '#downloads-btn',
        //     intro: 'Download the current map items here',
        //     position: 'bottom'
        // },
        // {
        //     element: '#about-btn',
        //     intro: 'Learn more about the project here',
        //     position: 'bottom'
        // }
    ]
    )
    return introguide
}
